<template>
	<div class="uploadIcon">
		<el-upload
			class="avatar-uploader"
			:class="{ isRound: round }"
			action=""
			:multiple="false"
			:accept="isIcon ? '.svg' : 'image/*'"
			:auto-upload="true"
			:show-file-list="false"
			:http-request="handleChangeUpload"
		>
			<i class="avatar-uploader-icon el-icon-plus" v-if="!value"></i>
			<div v-else class="avatar_body">
				<i v-html="value" class="svgIcon" v-if="isIcon" />
				<img :src="value" class="avatar" v-else />
				<div class="edit_model">
					<i class="el-icon-edit"></i>
				</div>
			</div>
		</el-upload>
	</div>
</template>

<script>
import uploadService from 'sky-ossupload';
import { getDomain } from 'sky-domain';
import OSS from 'ali-oss';
import skyRequest from 'skytech-request';

export default {
	name: 'uploadIcon',
	props: ['round', 'value', 'isIcon'],
	methods: {
		async handleChangeUpload(param) {
			if (this.isIcon) this.uploadIcon(param);
			else this.uploadImage(param);
		},
		// 上传图标
		uploadIcon(param) {
			let that = this;

			// 用于触发父组件的loading
			that.$emit('goLoading');

			const reader = new FileReader();
			reader.onload = event => {
				const content = event.target.result;

				that.$emit('input', content);
				that.$emit('change');
			};

			reader.readAsText(param.file); // 读取文件内容
		},
		// 上传图片
		async uploadImage(param) {
			let that = this;

			// 用于触发父组件的loading
			that.$emit('goLoading');

			//自定义文件上传
			let fileObj = param.file;

			try {
				let oss = uploadService({
					request: skyRequest,
					getHost: getDomain,
					platform: that.platform || 'iglobalwin-pub-oss',
					// OSS,
				});

				let convert = await oss.convert({
					file: fileObj,
				});

				let files = await oss.fileUpload({
					...convert,
					OSS,
				});
				that.$message.success('文件上传成功');
				that.$emit('input', files.url);
				that.$emit('change');
			} catch (e) {
				console.error(e);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.uploadIcon {
	::v-deep .avatar-uploader {
		.el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.el-upload {
			width: 56px;
			height: 56px;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.el-upload:hover {
			border-color: #409eff;
		}

		.avatar-uploader-icon {
			font-size: 20px;
			color: #8c939d;
			width: 55px;
			height: 55px;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.avatar_body {
			width: 55px;
			height: 55px;
			position: relative;
			display: flex;
			justify-content: center;
			align-items: center;

			.avatar,
			.edit_model {
				width: 100%;
				height: 100%;
			}

			.svgIcon {
				display: flex;
				justify-content: center;
				align-items: center;

				svg {
					width: 100%;
					height: 100%;
				}
			}

			.edit_model {
				position: absolute;
				top: 0;
				left: 0;
				display: none;
				background-color: #00000080;

				.el-icon-edit {
					color: #fff;
					font-size: 18px;
				}
			}

			&:hover {
				.edit_model {
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
	}

	::v-deep .isRound {
		.el-upload {
			border-radius: 50% !important;
		}
	}
}
</style>
